import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

export class SkioPlanPickerSubscriptionOnlyComponent extends LitElement {
  static properties = {
    product: { type: Object },
    selectedVariant: { type: Object },
    selectedSellingPlan: { type: Object },
    currency: { type: String },
    language: { type: String },
    formId: { type: String },
  };

  static styles = css`
    .skio-plan-picker {
      display: flex;
      align-items: center;
      width: auto;
      gap: 0.5rem;
      margin: 0.5rem 0 0.5rem 0;
    }
    .skio-frequency {
      font-size: 16px;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-color: transparent;
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='%23345c19' stroke-miterlimit='10' d='M.5 7.5L8 15l7.5-7.5'/%3E%3C/svg%3E");
      background-position: center right 16px;
      background-repeat: no-repeat;
      background-size: 16px;
      border: 1px solid;
      border-radius: 30px;
      color: inherit;
      display: inline-block;
      font: inherit;
      cursor: pointer;
      padding: 10px calc(1.5em + 32px) 10px 1em;
      width: auto;
    }
  `;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;
    this.selectedSellingPlan = null;
    this.currency = 'USD';
    this.language = 'en-US';
    this.formId = null;
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.product) {
      this.selectedVariant = JSON.parse(this.getAttribute('selectedVariant')) || this.product.variants[0];
      this.updateSellingPlans();
    }
  }

  updateSellingPlans() {
    const skioSellingPlanGroup = this.product.selling_plan_groups.find(
      group => group.app_id === 'SKIO'
    );
    if (skioSellingPlanGroup) {
      this.sellingPlans = skioSellingPlanGroup.selling_plans;
      this.selectedSellingPlan = this.sellingPlans[0];
      this.dispatchSellingPlanChangeEvent();
    }
  }

  render() {
    if (!this.product || !this.selectedVariant || !this.sellingPlans) return html``;

    return html`
    <div class="skio-plan-picker">
      <p>Delivery every</p>    
      <select class="skio-frequency" @change=${this.handleFrequencyChange}>
        ${this.sellingPlans.map(plan => html`
          <option value=${plan.id}>${plan.name.replace('Every ', '')}</option>
        `)}
      </select>
    </div>
    `;
  }

  handleFrequencyChange(e) {
    const selectedPlanId = e.target.value;
    this.selectedSellingPlan = this.sellingPlans.find(plan => plan.id.toString() === selectedPlanId);
    console.log('New selected selling plan:', this.selectedSellingPlan);
    this.dispatchSellingPlanChangeEvent();
  }

  dispatchSellingPlanChangeEvent() {
    const event = new CustomEvent('skio-selling-plan-changed', {
      bubbles: true,
      composed: true,
      detail: {
        selectedSellingPlan: this.selectedSellingPlan,
        price: this.getSubscriptionPrice()
      }
    });
    this.dispatchEvent(event);
  }

  getSubscriptionPrice() {
    if (!this.selectedSellingPlan) return this.selectedVariant.price;

    const allocation = this.selectedVariant.selling_plan_allocations.find(
      a => a.selling_plan_id.toString() === this.selectedSellingPlan.id.toString()
    );
    return allocation ? allocation.price : this.selectedVariant.price;
  }

  formatPrice(price) {
    return this.moneyFormatter.format(price / 100);
  }
}

customElements.define('skio-plan-picker-subscription-only', SkioPlanPickerSubscriptionOnlyComponent);